import React, { memo } from 'react';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type Props = {
	onClick: () => void;
};

export const RenameItem = memo(({ onClick }: Props) => {
	const { formatMessage } = useIntl();

	return <DropdownItem onClick={onClick}>{formatMessage(messages.renameItem)}</DropdownItem>;
});
